import { Component} from '@angular/core';
import { Subscription } from 'rxjs';
import { ToasterService } from '../../services/toaster.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent  {
  subscription: Subscription;
  isLoader: boolean = false;
  isLogin:boolean=false;


  constructor(private loaderandtoastService: ToasterService) { 
    this.subscription = this.loaderandtoastService.getLoader().subscribe((res)=> {
      this.isLoader = res;
    })
    this.subscription = this.loaderandtoastService.getisLogin().subscribe((res)=> {
      this.isLogin = res;
    })
  }


  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
